/**
 * @author jakubmaslon
 * @since 2020-07-03
 */

import * as React from "react";
import styled from "styled-components";

import { Testimonial } from "@ui/Molecules";
import { rem } from "@ui/helpers";
import { DraggableCarousel } from "@ui/Molecules/DraggableCarousel";

interface Testimonial {
  quote: string;
  author: string;
  rating: number;
}

interface Props {
  testimonials: Testimonial[];
}

const Testimonials = (props: Props): React.ReactElement => (
  <Wrapper>
    <DraggableCarousel
      slidesToShow={{
        mobile: 1,
        tablet: 2,
        desktop: 3,
      }}
    >
      {props.testimonials.map(testimonial => (
        <TestimonialWrapper key={testimonial.quote}>
          <Testimonial
            quote={testimonial.quote}
            author={testimonial.author}
            rating={testimonial.rating}
          />
        </TestimonialWrapper>
      ))}
    </DraggableCarousel>
  </Wrapper>
);

Testimonials.displayName = "Testimonials";

export { Testimonials };

const Wrapper = styled.div`
  width: 100%;
`;

const TestimonialWrapper = styled.div`
  max-width: ${rem(240)};
  min-width: ${rem(240)};

  ${props => props.theme.breakpoints.desktop} {
    max-width: ${rem(270)};
    min-width: ${rem(270)};
  }
`;
